// extracted by mini-css-extract-plugin
export default {"root":"ParticlesBackground_root__LVuAO","particles":"ParticlesBackground_particles__d+LMZ"};